var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _path13, _rect5, _circle4, _path14, _path15, _circle5, _path16, _ellipse3, _path17, _path18, _path19, _path20, _circle6, _ellipse4, _path21, _path22, _path23, _path24, _circle7, _rect6, _rect7, _rect8, _rect9, _path25, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChildPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 169,
    viewBox: "0 0 257 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0373 93.9314C17.0373 115.111 35.4332 132.28 58.1256 132.28C80.818 132.28 99.2139 115.111 99.2139 93.9314C99.2139 72.7518 80.818 55.5824 58.1256 55.5824C35.4332 55.5824 17.0373 72.7518 17.0373 93.9314Z",
    fill: "url(#paint0_linear_1954_540)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4735 51.3271H58.6332H55.3864V56.7998H61.4735V51.3271Z",
    fill: "url(#paint1_linear_1954_540)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.24679,
    cy: 7.24679,
    r: 7.24679,
    transform: "matrix(-1 0 0 1 65.2217 38.4805)",
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6449 135.324C33.4492 135.324 13.8348 117.012 13.8348 94.4227C13.8348 80.8196 20.9478 68.7675 31.891 61.3315C32.9978 60.5794 34.3185 60.2207 35.6567 60.2207H79.6332C80.9713 60.2207 82.2921 60.5794 83.3989 61.3315C94.342 68.7675 101.455 80.8196 101.455 94.4227C101.455 117.012 81.8406 135.324 57.6449 135.324Z",
    fill: "url(#paint2_linear_1954_540)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.48783,
    cy: 6.53969,
    rx: 3.48783,
    ry: 6.53969,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 95.0254 119.971)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6257 128.635C78.8382 126.821 80.3307 122.452 83.9593 118.877C87.5878 115.302 91.9784 113.875 93.7659 115.689C95.5534 117.503 94.0609 121.872 90.4324 125.447C86.8038 129.022 82.4132 130.449 80.6257 128.635ZM83.743 126.309C82.6057 125.154 83.5553 122.375 85.8641 120.1C88.173 117.825 90.9666 116.917 92.104 118.071C93.2414 119.226 92.2917 122.006 89.9829 124.28C87.6741 126.555 84.8804 127.463 83.743 126.309Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1719 123.664L83.1344 121.076L88.3108 117.001L90.3483 119.589L85.1719 123.664ZM96.1844 127.089L95.5384 130.319L96.1844 127.089ZM103.153 120.09C104.002 118.481 105.994 117.865 107.603 118.713C109.212 119.562 109.829 121.555 108.98 123.164L103.153 120.09ZM90.3483 119.589C92.1575 121.888 93.4847 122.801 94.3225 123.209C95.2156 123.645 95.6576 123.625 96.8304 123.859L95.5384 130.319C95.0642 130.224 93.3254 130.053 91.4338 129.13C89.4868 128.18 87.4254 126.527 85.1719 123.664L90.3483 119.589ZM96.8304 123.859C96.6652 123.826 96.8871 123.896 97.6541 123.658C98.327 123.449 99.1422 123.09 99.9802 122.618C100.814 122.148 101.589 121.613 102.194 121.098C102.496 120.841 102.731 120.611 102.902 120.417C102.987 120.321 103.049 120.243 103.092 120.183C103.113 120.153 103.128 120.13 103.139 120.114C103.149 120.097 103.153 120.089 103.153 120.09L108.98 123.164C108.366 124.328 107.382 125.334 106.463 126.116C105.495 126.939 104.364 127.71 103.214 128.358C102.068 129.003 100.821 129.574 99.6054 129.95C98.4839 130.298 96.9914 130.61 95.5384 130.319L96.8304 123.859Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1972 123.696L83.1286 121.132L88.2556 116.995L90.3241 119.558L85.1972 123.696ZM94.2083 126.76L95.334 123.664L94.2083 126.76ZM102.697 118.905C103.396 117.226 105.325 116.432 107.004 117.131C108.684 117.831 109.478 119.76 108.778 121.439L102.697 118.905ZM108.778 121.439C108.611 121.84 108.418 122.227 108.207 122.597L102.481 119.34C102.571 119.182 102.642 119.036 102.697 118.905L108.778 121.439ZM94.6173 130.233C94.1084 130.162 93.5927 130.041 93.0826 129.856L95.334 123.664C95.3706 123.678 95.4315 123.695 95.5231 123.708L94.6173 130.233ZM93.0826 129.856C92.9209 129.797 92.7706 129.744 92.6304 129.695L94.7739 123.466C94.9492 123.526 95.1355 123.592 95.334 123.664L93.0826 129.856ZM85.527 124.105C85.4213 123.974 85.3114 123.837 85.1972 123.696L90.3241 119.558C90.4424 119.705 90.556 119.846 90.6653 119.982L85.527 124.105Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8961 122.945C81.5957 121.591 82.6353 120.181 83.9593 118.877C86.0125 116.854 88.3097 115.519 90.2413 115.069L89.4262 117.799C88.2963 118.165 87.0195 118.962 85.8641 120.1C84.9377 121.013 84.2301 122.007 83.7884 122.945H80.8961Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99974,
    cy: 6.99974,
    r: 6.99974,
    transform: "matrix(-0.860508 -0.509437 -0.509437 0.860508 117.926 113.469)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8508,
    cy: 121.472,
    rx: 3.48783,
    ry: 6.53969,
    transform: "rotate(-44.9872 33.8508 121.472)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1614 127.977C42.9489 126.163 41.4564 121.794 37.8278 118.219C34.1993 114.644 29.8087 113.216 28.0212 115.031C26.2337 116.845 27.7262 121.214 31.3547 124.789C34.9833 128.364 39.3739 129.791 41.1614 127.977ZM38.0441 125.651C39.1814 124.496 38.2318 121.716 35.923 119.442C33.6142 117.167 30.8205 116.259 29.6831 117.413C28.5457 118.568 29.4954 121.347 31.8042 123.622C34.113 125.897 36.9067 126.805 38.0441 125.651Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6145 123.006L38.6521 120.418L33.4756 116.343L31.4381 118.931L36.6145 123.006ZM24.2999 131.18L21.3529 129.709L24.2999 131.18ZM28.0177 140.827C29.7068 141.502 31.6238 140.681 32.2994 138.991C32.9751 137.302 32.1535 135.385 30.4644 134.71L28.0177 140.827ZM31.4381 118.931C29.6455 121.208 27.9634 122.57 26.2568 124.009C24.5727 125.428 22.6716 127.068 21.3529 129.709L27.2469 132.652C27.902 131.34 28.8328 130.454 30.5028 129.046C32.1503 127.657 34.3445 125.89 36.6145 123.006L31.4381 118.931ZM21.3529 129.709C20.502 131.413 20.1952 133.219 20.7049 134.979C21.1975 136.679 22.3113 137.84 23.3126 138.591C25.0947 139.928 27.7329 140.713 28.0177 140.827L30.4644 134.71C30.1772 134.595 29.8186 134.471 29.5579 134.379C29.2596 134.274 28.968 134.169 28.674 134.051C28.062 133.806 27.5871 133.562 27.266 133.321C26.95 133.084 26.9934 133.01 27.0328 133.146C27.0893 133.341 26.9464 133.254 27.2469 132.652L21.3529 129.709Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6144 123.006L38.6519 120.418L33.4755 116.343L31.438 118.931L36.6144 123.006ZM24.9585 130.054L22.0117 128.582L24.9585 130.054ZM28.2489 140.909C29.9837 141.457 31.8341 140.495 32.3819 138.76C32.9297 137.025 31.9674 135.175 30.2326 134.627L28.2489 140.909ZM30.2326 134.627C30.0238 134.561 29.8251 134.496 29.6359 134.432L27.5238 140.672C27.7588 140.752 28.0005 140.831 28.2489 140.909L30.2326 134.627ZM27.6371 132.079C27.7183 131.906 27.8075 131.722 27.9053 131.526L22.0117 128.582C21.8952 128.816 21.7817 129.048 21.6732 129.28L27.6371 132.079ZM27.9053 131.526C27.9923 131.352 28.0793 131.195 28.166 131.052L22.5302 127.64C22.3486 127.94 22.1759 128.254 22.0117 128.582L27.9053 131.526ZM36.0379 123.716C36.2288 123.488 36.421 123.252 36.6144 123.006L31.438 118.931C31.2867 119.123 31.1378 119.306 30.9914 119.481L36.0379 123.716Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.891 122.286C40.1914 120.933 39.1518 119.523 37.8278 118.219C35.7746 116.196 33.4774 114.86 31.5458 114.411L32.3609 117.141C33.4908 117.507 34.7676 118.303 35.923 119.442C36.8494 120.354 37.557 121.349 37.9987 122.286H40.891Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99974,
    cy: 6.99974,
    r: 6.99974,
    transform: "matrix(-0.860508 -0.509437 -0.509437 0.860508 41.7588 137.845)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.988199,
    height: 6.91739,
    rx: 0.494099,
    transform: "matrix(-1 0 0 1 71.7676 119.808)",
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.988199,
    height: 6.91739,
    rx: 0.494099,
    transform: "matrix(-1 0 0 1 65.8389 119.808)",
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.988199,
    height: 11.8584,
    rx: 0.494099,
    transform: "matrix(-1 0 0 1 68.8027 117.831)",
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 73.7855,
    height: 37.5516,
    rx: 18.7758,
    transform: "matrix(-1 0 0 1 103.707 70.4033)",
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 2.73
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9996 88.8493C79.9996 87.8977 80.187 86.9553 80.5512 86.0761C80.9154 85.1969 81.4492 84.398 82.1221 83.7251C82.795 83.0521 83.5939 82.5184 84.4731 82.1542C85.3524 81.79 86.2947 81.6025 87.2464 81.6025C88.198 81.6025 89.1404 81.79 90.0196 82.1542C90.8988 82.5184 91.6977 83.0521 92.3706 83.7251C93.0436 84.398 93.5773 85.1969 93.9415 86.0761C94.3057 86.9553 94.4932 87.8977 94.4932 88.8493",
    stroke: "#72B2FF",
    strokeWidth: 3.73136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0601 88.8493C47.0601 87.8977 47.2476 86.9553 47.6118 86.0761C47.9759 85.1969 48.5097 84.398 49.1827 83.7251C49.8556 83.0521 50.6545 82.5184 51.5337 82.1542C52.4129 81.79 53.3553 81.6025 54.3069 81.6025C55.2586 81.6025 56.2009 81.79 57.0801 82.1542C57.9594 82.5184 58.7582 83.0521 59.4312 83.7251C60.1041 84.398 60.6379 85.1969 61.0021 86.0761C61.3663 86.9553 61.5537 87.8977 61.5537 88.8493",
    stroke: "#72B2FF",
    strokeWidth: 3.73136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4287,
    y: 108.823,
    width: 17.7165,
    height: 34.7515,
    rx: 4.24757,
    transform: "rotate(21.9831 42.4287 108.823)",
    fill: "#FF9154"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7947,
    cy: 117.77,
    r: 1.60422,
    transform: "rotate(4.53112 53.7947 117.77)",
    fill: "#F56414"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M252.359 90.6438C252.359 121.264 225.763 146.086 192.956 146.086C160.149 146.086 133.554 121.264 133.554 90.6438C133.554 60.0238 160.149 35.2014 192.956 35.2014C225.763 35.2014 252.359 60.0238 252.359 90.6438Z",
    fill: "url(#paint3_linear_1954_540)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.116 22.8809H196.916V36.9615H188.116V22.8809Z",
    fill: "url(#paint4_linear_1954_540)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.516,
    cy: 12.3205,
    r: 12.3205,
    fill: "#000F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.396 150.486C228.39 150.486 256.759 124.088 256.759 91.524C256.759 71.8349 246.388 54.3999 230.453 43.6909C228.973 42.6966 227.214 42.2188 225.431 42.2188H161.361C159.578 42.2188 157.819 42.6966 156.339 43.6909C140.404 54.3999 130.033 71.8349 130.033 91.524C130.033 124.088 158.402 150.486 193.396 150.486Z",
    fill: "url(#paint5_linear_1954_540)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.304,
    cy: 128.341,
    rx: 4.65912,
    ry: 8.73585,
    transform: "rotate(-44.9872 144.304 128.341)",
    fill: "#236DC1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.07 137.03C156.458 134.607 154.464 128.771 149.617 123.995C144.77 119.22 138.905 117.313 136.517 119.736C134.129 122.16 136.123 127.996 140.97 132.772C145.817 137.547 151.682 139.454 154.07 137.03ZM149.906 133.923C151.425 132.381 150.157 128.667 147.072 125.629C143.988 122.59 140.256 121.377 138.737 122.919C137.218 124.461 138.486 128.175 141.571 131.213C144.655 134.252 148.387 135.465 149.906 133.923Z",
    fill: "#468BDC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.996 130.391L150.718 126.933L143.803 121.49L141.081 124.947L147.996 130.391ZM133.286 134.966L134.148 139.28L133.286 134.966ZM123.977 125.616C122.843 123.466 120.181 122.643 118.032 123.777C115.882 124.911 115.059 127.573 116.193 129.722L123.977 125.616ZM141.081 124.947C138.665 128.017 136.892 129.237 135.773 129.783C134.58 130.365 133.989 130.338 132.423 130.651L134.148 139.28C134.782 139.154 137.105 138.925 139.632 137.692C142.232 136.423 144.986 134.215 147.996 130.391L141.081 124.947ZM132.423 130.651C132.643 130.607 132.347 130.7 131.322 130.382C130.423 130.103 129.334 129.624 128.215 128.993C127.101 128.365 126.066 127.65 125.257 126.962C124.855 126.62 124.541 126.311 124.311 126.052C124.198 125.925 124.116 125.82 124.058 125.74C124.03 125.7 124.01 125.67 123.996 125.648C123.982 125.626 123.976 125.615 123.977 125.616L116.193 129.722C117.013 131.276 118.328 132.621 119.555 133.665C120.849 134.765 122.359 135.794 123.895 136.66C125.426 137.522 127.092 138.284 128.716 138.788C130.214 139.252 132.208 139.669 134.148 139.28L132.423 130.651Z",
    fill: "#000F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.963 130.432L150.727 127.007L143.878 121.481L141.115 124.905L147.963 130.432ZM135.926 134.525L134.422 130.39L135.926 134.525ZM124.587 124.032C123.652 121.789 121.076 120.728 118.833 121.663C116.59 122.598 115.529 125.174 116.464 127.417L124.587 124.032ZM116.464 127.417C116.687 127.953 116.944 128.469 117.226 128.965L124.875 124.613C124.755 124.402 124.66 124.207 124.587 124.032L116.464 127.417ZM135.38 139.165C136.06 139.07 136.748 138.908 137.43 138.66L134.422 130.39C134.373 130.408 134.292 130.431 134.17 130.448L135.38 139.165ZM137.43 138.66C137.646 138.582 137.847 138.511 138.034 138.446L135.171 130.125C134.936 130.205 134.687 130.293 134.422 130.39L137.43 138.66ZM147.523 130.979C147.664 130.803 147.811 130.621 147.963 130.432L141.115 124.905C140.957 125.101 140.805 125.29 140.659 125.472L147.523 130.979Z",
    fill: "#0F4688"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.709 129.429C152.774 127.621 151.386 125.738 149.617 123.995C146.874 121.293 143.806 119.509 141.225 118.909L142.314 122.555C143.823 123.045 145.529 124.108 147.072 125.629C148.31 126.848 149.255 128.176 149.845 129.429H153.709Z",
    fill: "#468BDC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.053,
    cy: 120.054,
    r: 9.3504,
    transform: "rotate(-30.6263 117.053 120.054)",
    fill: "#85B7F2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.65912,
    cy: 8.73585,
    rx: 4.65912,
    ry: 8.73585,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 232.245 127.771)",
    fill: "#236DC1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.009 139.346C210.621 136.922 212.615 131.086 217.462 126.311C222.309 121.535 228.174 119.628 230.562 122.052C232.95 124.475 230.956 130.311 226.109 135.087C221.262 139.863 215.397 141.769 213.009 139.346ZM217.173 136.238C215.654 134.696 216.922 130.983 220.007 127.944C223.091 124.906 226.823 123.692 228.342 125.235C229.861 126.777 228.593 130.49 225.509 133.529C222.424 136.567 218.693 137.781 217.173 136.238Z",
    fill: "#468BDC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.083 132.706L216.361 129.249L223.276 123.805L225.997 127.263L219.083 132.706ZM235.533 143.625L239.469 141.659L235.533 143.625ZM230.566 156.511C228.31 157.413 225.749 156.316 224.847 154.06C223.944 151.803 225.042 149.242 227.298 148.34L230.566 156.511ZM225.997 127.263C228.392 130.304 230.639 132.124 232.919 134.045C235.168 135.942 237.708 138.131 239.469 141.659L231.596 145.591C230.721 143.838 229.478 142.654 227.247 140.774C225.046 138.919 222.115 136.558 219.083 132.706L225.997 127.263ZM239.469 141.659C240.606 143.935 241.016 146.349 240.335 148.699C239.677 150.971 238.189 152.522 236.852 153.525C234.471 155.311 230.947 156.359 230.566 156.511L227.298 148.34C227.682 148.186 228.161 148.021 228.509 147.898C228.907 147.757 229.297 147.617 229.69 147.46C230.507 147.133 231.142 146.807 231.57 146.485C231.993 146.169 231.935 146.069 231.882 146.251C231.807 146.511 231.997 146.395 231.596 145.591L239.469 141.659Z",
    fill: "#000F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.083 132.706L216.361 129.249L223.276 123.805L225.998 127.263L219.083 132.706ZM234.653 142.121L238.589 140.155V140.155L234.653 142.121ZM230.258 156.621C227.94 157.353 225.468 156.068 224.737 153.75C224.005 151.433 225.29 148.961 227.608 148.229L230.258 156.621ZM227.608 148.229C227.887 148.141 228.152 148.055 228.405 147.969L231.226 156.305C230.912 156.411 230.589 156.517 230.258 156.621L227.608 148.229ZM231.075 144.825C230.966 144.594 230.847 144.349 230.717 144.087L238.589 140.155C238.745 140.466 238.897 140.777 239.042 141.086L231.075 144.825ZM230.717 144.087C230.6 143.855 230.484 143.645 230.368 143.454L237.897 138.896C238.139 139.297 238.37 139.716 238.589 140.155L230.717 144.087ZM219.853 133.654C219.598 133.35 219.341 133.034 219.083 132.706L225.998 127.263C226.2 127.519 226.399 127.764 226.594 127.997L219.853 133.654Z",
    fill: "#0F4688"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.37 131.744C214.305 129.937 215.693 128.053 217.462 126.311C220.205 123.608 223.274 121.825 225.854 121.224L224.765 124.87C223.256 125.36 221.55 126.424 220.007 127.944C218.769 129.164 217.824 130.492 217.234 131.744H213.37Z",
    fill: "#468BDC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.02,
    cy: 155.811,
    r: 9.3504,
    transform: "rotate(-30.6263 225.02 155.811)",
    fill: "#86B8F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 177.995,
    y: 128.725,
    width: 1.32006,
    height: 9.2404,
    rx: 0.660028,
    fill: "#5998E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 185.915,
    y: 128.725,
    width: 1.32006,
    height: 9.2404,
    rx: 0.660028,
    fill: "#5998E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 181.955,
    y: 126.085,
    width: 1.32006,
    height: 15.8407,
    rx: 0.660028,
    fill: "#5998E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 128.565,
    y: 57.0827,
    width: 102.084,
    height: 53.6823,
    rx: 26.8412,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 3.52015
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.047 86.1236C164.047 84.9679 163.819 83.8236 163.377 82.7559C162.935 81.6882 162.287 80.718 161.469 79.9008C160.652 79.0836 159.682 78.4354 158.614 77.9931C157.547 77.5509 156.402 77.3232 155.247 77.3232C154.091 77.3232 152.947 77.5509 151.879 77.9931C150.811 78.4354 149.841 79.0836 149.024 79.9008C148.207 80.718 147.558 81.6882 147.116 82.7559C146.674 83.8236 146.446 84.9679 146.446 86.1236",
    stroke: "#72B2FF",
    strokeWidth: 4.40019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 188.809,
    y: 80.8438,
    width: 14.9606,
    height: 4.40019,
    rx: 2.20009,
    fill: "#72B2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1954_540",
    x1: 58.1256,
    y1: 47.0604,
    x2: 58.1256,
    y2: 132.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1954_540",
    x1: 58.1256,
    y1: 47.0604,
    x2: 58.1256,
    y2: 132.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1954_540",
    x1: 57.6449,
    y1: 53.5216,
    x2: 57.6449,
    y2: 135.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1954_540",
    x1: 192.956,
    y1: 22.8809,
    x2: 192.956,
    y2: 146.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1954_540",
    x1: 192.956,
    y1: 22.8809,
    x2: 192.956,
    y2: 146.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1954_540",
    x1: 193.396,
    y1: 32.5614,
    x2: 193.396,
    y2: 150.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildPhone);
export default __webpack_public_path__ + "static/media/child_phone.8398bb5a9f7bd8f806579a4aadebd180.svg";
export { ForwardRef as ReactComponent };